module.exports = __webpack_public_path__ + "static/media/EasyWords_ios_2.0ff33079.jpg";